import { getAppUrl } from '../../helpers/requestHelpers';

const baseParams = {
  client_id: 'QT6xCtFyNRNPSsopvf4gbSxhPgxuzV3at4JoSg0YG7s',
  redirect_uri: `${getAppUrl()}/#/auth`,
};

export default baseParams;
